import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from '../Transition';

class IsBrowser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMounted: false
    };
  }

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    const { children, placeHolder, withTransition } = this.props;
    const { isMounted } = this.state;
    const content = withTransition ? <Transition>{children}</Transition> : children;

    return isMounted ? content : placeHolder;
  }
}

IsBrowser.defaultProps = {
  placeHolder: null,
  withTransition: false
};

IsBrowser.propTypes = {
  withTransition: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  placeHolder: PropTypes.element
};

export default IsBrowser;
